export const OPTIONS = {
  AFFECTED: { EN: 'Affected', DE: 'Betroffen' },
  NOT_AFFECTED: { EN: 'Not affected', DE: 'Nicht betroffen' },
};

export const COLUMNS = {
  AGGREGATE: [
    { colName: 'TotallyCode', colTitle: null },
    { colName: 'CodeConditions', colTitle: 'affectedVehicles.aggregate.codeCondition', flex: 1.2 },
    { colName: 'Serie', colTitle: 'affectedVehicles.aggregate.serie', flex: 1.2 },
    { colName: 'TypeVersion', colTitle: 'affectedVehicles.aggregate.typeVersion', flex: 1 },
    { colName: 'Aggregat', colTitle: 'affectedVehicles.aggregate.aggregat', flex: 1.2 },
    { colName: 'Designation', colTitle: 'affectedVehicles.aggregate.designation', flex: 2 },
  ],
  COUNTRY_VARIANTS: [
    { colName: 'HiddenId', colTitle: null },
    { colName: 'CountryCode', colTitle: 'affectedVehicles.countryVariants.countryCode', flex: 1 },
    { colName: 'Country', colTitle: 'affectedVehicles.countryVariants.country', flex: 1 },
  ],
  PAINT_CODE: [
    { colName: 'HiddenId', colTitle: null },
    { colName: 'PaintCode', colTitle: 'affectedVehicles.paintCode.paintCode', flex: 1 },
    { colName: 'CodeId', colTitle: 'affectedVehicles.codeId', flex: 1 },
    { colName: 'Description', colTitle: 'description.label', flex: 1 },
  ],
  SPECIAL_EQUIPMENT: [
    { colName: 'HiddenId', colTitle: null },
    { colName: 'SpecialEquipmentCode', colTitle: 'affectedVehicles.specialEquipment.columnSpecialEquipmentCode', flex: 1 },
    { colName: 'CodeId', colTitle: 'affectedVehicles.codeId', flex: 1 },
    { colName: 'Description', colTitle: 'description.label', flex: 1 },
  ],
  VEHICLE_MODEL_DESIGNATION: [
    { colName: 'TotallyCode', colTitle: null },
    { colName: 'baumusterVariant', colTitle: 'affectedVehicles.vehicleModelDesignation.modelDesignation', flex: 1.6 },
    { colName: 'codeCondition', colTitle: 'affectedVehicles.vehicleModelDesignation.codeCondition', flex: 1.6 },
    { colName: 'typeVersion', colTitle: 'affectedVehicles.vehicleModelDesignation.typeVersion', flex: 1 },
    { colName: 'steering', colTitle: 'affectedVehicles.vehicleModelDesignation.steering', flex: 1.2 },
    { colName: 'driveType', colTitle: 'affectedVehicles.vehicleModelDesignation.driveType', flex: 1 },
    { colName: 'bmaaDesignation', colTitle: 'affectedVehicles.vehicleModelDesignation.bmaaDesignation', flex: 2 },
    { colName: 'salesDesignation', colTitle: 'affectedVehicles.vehicleModelDesignation.salesDesignation', flex: 1.6 },
  ],
};

export const INPUTS = [
  {
    tab: 'AGGREGATE',
    inputs: [
      { attr: 'aggregateSelecteds', label: 'affectedVehicles.aggregate.selectedEngine' },
      { attr: 'aggregateSelectionAccording', label: 'affectedVehicles.aggregate.selectionAccording' },
      { attr: 'aggregateComment', label: 'comment' },
    ],
  },
  {
    tab: 'COUNTRY_VARIANTS',
    inputs: [
      { attr: 'countryVariantsSelecteds', label: 'affectedVehicles.countryVariants.selectedCountries' },
      { attr: 'countryVariantsSelectionAccording', label: 'affectedVehicles.countryVariants.selectionAccording' },
      { attr: 'countryVariantsComment', label: 'comment' },
    ],
  },
  {
    tab: 'PAINT_CODE',
    inputs: [
      { attr: 'paintCodeSelecteds', label: 'affectedVehicles.paintCode.selectedPaintCode' },
      { attr: 'paintCodeSelectionAccording', label: 'affectedVehicles.paintCode.selectionAccording' },
      { attr: 'paintCodeComment', label: 'comment' },
    ],
  },
  {
    tab: 'VEHICLE_MODEL_DESIGNATION',
    inputs: [
      { attr: 'vehicleModelDesignationSelecteds', label: 'affectedVehicles.vehicleModelDesignation.selected' },
      { attr: 'vehicleModelDesignationSelectionAccording', label: 'affectedVehicles.vehicleModelDesignation.select' },
      { attr: 'vehicleModelDesignationComment', label: 'comment' },
    ],
  },
];
